<template>
  <div class="receive-account" :style="{ 'min-height': (documentClientHeight - 190) + 'px' }">
    <el-tabs v-model="receiveTabs" class="client-tabs">
      <el-tab-pane label="进口用" name="import" v-if="bizType.clientImportRole">
        <div class="account">
          <div class="title">¥ 人民币收款账号</div>
          <div class="opt">
            <div
              class="copy"
              @click="copyInfo('import')"
            >
              <ab-svg name="copy"></ab-svg>
              复制
            </div>
            <el-button
              type="primary"
              :loading="dlLoading"
              @click="downloadFile('收款账号-一咻宁波银行.pdf')"
            >下载账号</el-button>
          </div>
          <div class="text-detail">
            <p>公司名称：深圳市一咻科技有限公司</p>
            <p>开户银行：宁波银行股份有限公司深圳前海支行</p>
            <p>银行账号：73190122000082155</p>
            <p>银行联行号：313584003159</p>
          </div>
        </div>
        <div class="tips">注意：若网银查不到宁波银行，请搜【城市商业银行】再查宁波银行</div>
      </el-tab-pane>

      <el-tab-pane label="出口用" name="export" v-if="bizType.clientExportRole">
        <div class="account">
          <div class="title">$ 美元收款账号</div>
          <div class="opt">
            <div
              class="copy"
              @click="copyInfo('export')"
            >
              <ab-svg name="copy"></ab-svg>
              复制
            </div>
            <el-button
              type="primary"
              :loading="dlLoading"
              @click="downloadFile('锦盛宁波银行NRA账户信息.pdf', 'https://scp-static.oss-cn-shenzhen.aliyuncs.com/receiptInfo/锦盛宁波银行NRA账户信息.pdf')"
            >下载账号</el-button>
          </div>
          <div class="text-detail">
            <p>公司名称：FUTURE PROMISING COMPANY LIMITED</p>
            <p>开户银行：BANK OF NINGBO, SHENZHEN BRANCH</p>
            <p>银行地址：4/F, HUANGTING PRODIUM BUILDING,JINTIAN ROAD,FUTIAN DISTRICT,SHENZHEN,CHINA 518000</p>
            <p>银行账号：NRA73192023001312</p>
            <p>SWIFT号：BKNBCN2NSHE</p>
          </div>
        </div>
        <div class="tips">注意：非美元币种打款账号请联系商务获取</div>

        <div class="invoice">
          <div class="hd">
            <span>开票信息</span>
            <el-button
              plain
              :loading="dlLoading"
              @click="downloadFile('一咻科技开票资料.pdf')"
            >下载信息</el-button>
          </div>
          <div class="bd">
            <div class="title">
              <div class="qr-code">
                <div class="box label">
                  二维码<br /><i class="note">如不清晰<br />直接退票</i>
                </div>
                <div class="text">XXXXXXXXXXXXX</div>
              </div>
              <div class="name">
                XXX增值税专用发票<br />抵扣联
              </div>
              <div class="info">
                <div class="num">NOXXXXXXXXX</div>
                <div class="text">
                  XXXXXXXXXXXXX<br />
                  开票日期：XXX 年 XXX 月 XXX日
                </div>
              </div>
            </div>

            <div class="table">
              <table>
                <tr>
                  <td rowspan="4" class="label" width="30">购货单位</td>
                  <td class="label" width="188">名称</td>
                  <td colspan="5" style="padding-left:14px">深圳市一咻科技有限公司<i class="note space">必须完全一致 | 不得增减或有错别字</i></td>
                  <td rowspan="4" class="label" width="30">密码区</td>
                  <td colspan="2" rowspan="4" width="268" align="center">
                    XXXXXXXXXXXXXXXXX<br />
                    XXXXXXXXXXXXXXXXX<br />
                    <i class="note">注意密码区的打印内容切<br />勿超出边框且应字迹清晰</i>
                  </td>
                </tr>
                <tr>
                  <td class="label">纳税人识别号</td>
                  <td colspan="5" style="padding-left:14px">91440300MA5FAM5Y44<i class="note space">必须完全一致</i></td>
                </tr>
                <tr>
                  <td class="label">地址、电话</td>
                  <td colspan="5" style="padding-left:14px">深圳市福田区华强北街道华航社区中航路 8 号新亚洲电子商城 515 0755-86713656<i class="note space">不得有错别字</i></td>
                </tr>
                <tr>
                  <td class="label">开户行及账号</td>
                  <td colspan="5" style="padding-left:14px">建设银行深圳蛇口支行&nbsp;&nbsp;44250100000400001806<i class="note space">不得有错别字</i></td>
                </tr>
                <tr>
                  <td colspan="2" class="label">货物或应税劳务名称</td>
                  <td class="label">规格型号</td>
                  <td class="label">单位</td>
                  <td class="label">数量</td>
                  <td class="label">单价</td>
                  <td colspan="2" class="label" width="150">金额</td>
                  <td class="label">税率</td>
                  <td class="label">税额</td>
                </tr>
                <tr>
                  <td colspan="2" class="note" align="center" style="padding:20px 0">要求与购销合同一致且名称<br />必须是中文或中文附加英文<br />不得为纯英文、字母或代码	</td>
                  <td class="note" align="center">必须与购销合同一致</td>
                  <td class="note" align="center">必须与购销合同一致</td>
                  <td class="note" align="center">必须与购销合同一致</td>
                  <td class="note" align="center">必须与购销合同一致</td>
                  <td colspan="2" class="note" align="center">必填项</td>
                  <td class="note" align="center">必填项</td>
                  <td class="note" align="center">必填项</td>
                </tr>
                <tr>
                  <td colspan="2" class="label">合计</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td colspan="2" class="note" align="center">必填项</td>
                  <td></td>
                  <td class="note" align="center">必填项</td>
                </tr>
                <tr>
                  <td colspan="2" class="label">价税合计（大写）</td>
                  <td></td>
                  <td colspan="3" class="note" align="center">必填项</td>
                  <td colspan="2" class="label" align="center">小写</td>
                  <td colspan="2" class="note" align="center">必填项</td>
                </tr>
                <tr>
                  <td rowspan="4" class="label">销售方</td>
                  <td align="center">名称</td>
                  <td colspan="4" rowspan="4" class="note" align="center" style="padding:20px 0">必须与销贷单位提供的《税务登记证》上的信息一致<br />且与购销合同中供货方名称等信息一致</td>
                  <td colspan="2" rowspan="4" class="label" align="center">备<br />注</td>
                  <td colspan="2" rowspan="4" class="note" align="center">合同号或其他要求注明的信息</td>
                </tr>
                <tr>
                  <td align="center">税务人识别号</td>
                </tr>
                <tr>
                  <td align="center">地址、电话</td>
                </tr>
                <tr>
                  <td align="center">开户行及账号</td>
                </tr>
              </table>
            </div>

            <div class="ft">
              <el-row>
                <el-col :span="5">
                  收款人：<i class="note">必须全名不得简写</i>
                </el-col>

                <el-col :span="5">
                  复核人：<i class="note">必须全名不得简写</i>
                </el-col>

                <el-col :span="7">
                  开票人：<i class="note">必须全名不得简写 | 不能与复核人为同一人</i>
                </el-col>

                <el-col :span="7">
                  销售方（章）：<i class="note">发票专用章务必清晰完整、不得缺损</i>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <textarea class="copy-text" id="copyText"></textarea>
  </div>
</template>

<script>
export default {
  name: 'receive-account',
  components: {

  },

  data() {
    return {
      receiveTabs: 'import',
      dlLoading: false
    }
  },

  computed: {
		documentClientHeight: {
			get() {
				return this.$store.state.documentClientHeight;
			},
			set(val) {
				this.$store.commit('updateDocumentClientHeight', val);
			}
		},
    bizType() {
      return this.$utils.getSessionStorage('bizType')
    },
  },

  created() {
    if(!this.bizType.clientImportRole) {
      this.receiveTabs = 'export'
    }
  },

  methods: {
    copyInfo(tab) {
      let infoText = ''
      if (tab === 'import') {
        infoText = '公司名称：深圳市一咻科技有限公司\n' +
        '开户银行：宁波银行股份有限公司深圳前海支行\n' +
        '银行账号：73190122000082155\n' +
        '银行联行号：313584003159'
      } else if (tab === 'export') {
        infoText = '公司名称：FUTURE PROMISING COMPANY LIMITED\n' +
        '开户银行：BANK OF NINGBO, SHENZHEN BRANCH\n' +
        '银行地址：4/F, HUANGTING PRODIUM BUILDING,JINTIAN ROAD,FUTIAN DISTRICT,SHENZHEN,CHINA 518000\n' +
        '银行账号：NRA73192023001312\n' +
        'SWIFT号：BKNBCN2NSHE'
      }
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = infoText // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },

    downloadFile(name, fileUrl) {
      this.dlLoading = true
      const domA = document.createElement('a')
      const url = fileUrl ? fileUrl : 'https://static.z-easy.com.cn/static/receiptInfo/' + name 
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        domA.href = URL.createObjectURL(blob)
        domA.download = name // 下载文件的名字
        document.body.appendChild(domA)
        domA.click()
      }).finally(() => {
        this.dlLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.receive-account {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 35px 40px 40px;
  font-size: 14px;
  text-align: left;
  .el-tabs .el-tabs__header {
    // display: none;
    margin-bottom: 26px;
  }
  .account {
    position: relative;
    min-height: 248px;
    padding-top: 50px;
    background: linear-gradient(270deg, #C9DFF9, #F8F8F8);
    box-shadow: 0px 3px 68px 0px rgba(0,0,0,0.05);
    border-radius: 16px;
    overflow: hidden;
    .title {
      position: absolute;
      top: 0;
      left: 0;
      height: 36px;
      padding: 0 16px;
      font-size: 16px;
      line-height: 36px;
      color: #f00;
      border-bottom-right-radius: 16px;
      background: #f3c3c6;
    }
    .opt {
      position: absolute;
      top: 25px;
      right: 25px;
      .copy {
        display: inline-block;
        margin-right: 30px;
        vertical-align: middle;
        cursor: pointer;
        .icon-svg {
          width: 16px;
          height: 16px;
          margin-top: 1px;
          vertical-align: text-top;
        }
      }
    }
    .text-detail {
      padding: 0 22px;
      p {
        line-height: 37px;
      }
    }
  }
  .tips {
    height: 52px;
    margin-top: -16px;
    padding: 16px 16px 0;
    line-height: 36px;
    color: #F87243;
    border-radius: 6px;
    background: #fae6df;
  }
  #pane-export .account {
    .title {
      color: #1F77F3;
      background: #c6dbf7;
    }
  }

  .invoice {
    margin-top: 26px;
    .hd {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        font-size: 18px;
      }
    }
    .bd {
      margin-top: 26px;
      padding: 30px;
      border: 1px solid #E5E5E5;
      .label {
        text-align: center;
        background-color: #f2f7ff;
      }
      .note {
        font-style: normal;
        color: #EE6E40;
        &.space {
          margin-left: 20px;
        }
      }
      .title {
        display: flex;
        justify-content: space-between;
        .qr-code {
          .box {
            width: 88px;
            height: 88px;
            padding-top: 20px;
            text-align: center;
          }
          .text {
            margin-top: 22px;
          }
        }
        .name {
          font-size: 24px;
          font-weight: bold;
          line-height: 42px;
          text-align: center;
        }
        .info {
          padding-top: 26px;
          line-height: 34px;
          text-align: right;
          .num {
            font-size: 18px;
          }
        }
      }
      .table {
        margin-top: 20px;
        line-height: 24px;
        table {
          width: 100%;
          border-collapse: collapse;
          td {
            padding: 5px 10px;
            border: 1px solid #F0F2F5;
          }
        }
      }
      .ft {
        margin-top: 20px;
      }
    }
  }
}
</style>
